    import React from 'react';
    import { Link } from "react-router-dom";
    import api from "../servicios/api";
    import { authHeaders } from "../servicios/auth";
    import { Navigate } from "react-router-dom";

    class Crearmultas extends React.Component {
        constructor(props) {
            super(props);
          this.state = {

    infraccionActual: null,
    datosCargados: false,

    infracciones: [],
    articulos: [],
    incisos: [],

    articuloSeleccionado: "",
    incisoSeleccionado: "",

    infraccionesSeleccionadas: [],

    tipo:"",
    tiposPlaca:[],

    modelo: "",
    marca: "",
    color: "",
    nit: "",
    dpi:"",
    nombre: "",
    nombrec:"",
    licencia:"",
    tipolicencia:"",
    
    lugar:"",
    placa:"",
    observaciones:"",
    foto: null,
    mensaje: "",
    mensajePlaca: "",
    redireccionar: false
}
        }
verificarPlaca = () => {

    const placa = this.state.placa;
    const tipo = this.state.tipo;

    if (placa.trim() === "" || tipo === "") {
        return;
    }

    fetch(api + "multas/verificar-placa?placa=" + placa + "&tipo=" + tipo, {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        if (datosRespuesta.existe) {

            const estado = Number(datosRespuesta.estadomulta);

            if (estado === 1) {
                this.setState({
                    mensajePlaca: "⚠️ Esta placa tiene una multa VIGENTE"
                });
            } else if (estado === 2) {
                this.setState({
                    mensajePlaca: "✅ Esta placa tiene una multa PAGADA"
                });
            } else if (estado === 4) {
                this.setState({
                    mensajePlaca: "❌ Esta placa tiene una multa ANULADA"
                });
            }

        } else {
            this.setState({
                mensajePlaca: "Sin multas registradas"
            });
        }

    })
    .catch(error => {
       
        this.setState({
            mensajePlaca: "Error al verificar placa"
        });
    });
}
        guardarMulta = () => {
    const totalMonto = this.state.infraccionesSeleccionadas.reduce(
        (total, item) => total + Number(item.monto || 0),
        0
    );

    const usuario = JSON.parse(localStorage.getItem("usuario"));

    const formData = new FormData();

    formData.append("placa", this.state.placa);
    formData.append("tipo", this.state.tipo);
    formData.append("modelo", this.state.modelo || "");
    formData.append("marca", this.state.marca);
    formData.append("color", this.state.color);
    formData.append("nit", this.state.nit || "");
    formData.append("dpi", this.state.dpi || "");
    formData.append("nombre", this.state.nombre || "");
    formData.append("nombrec", this.state.nombrec || "");
    formData.append("licencia", this.state.licencia || "");
    formData.append("tipolicencia", this.state.tipolicencia || "");
    formData.append("lugar", this.state.lugar);
    formData.append("observaciones", this.state.observaciones || "");
    formData.append("monto", totalMonto);
    formData.append("idagente", usuario.idusuario);

    this.state.infraccionesSeleccionadas.forEach((item, index) => {
        formData.append(`infracciones[${index}][idinfraccion]`, item.idinfraccion);
        formData.append(`infracciones[${index}][monto]`, item.monto);
    });

    if (this.state.foto) {
        formData.append("foto", this.state.foto);
    }

    fetch(api + "multas", {
        method: "POST",
        headers: {
            ...authHeaders(false)
        },
        body: formData
    })
    .then(respuesta => respuesta.json())
    .then((respuesta) => {
        if (respuesta.success) {
            this.imprimirMulta(respuesta.idmulta);

            alert("Multa guardada correctamente");

            this.setState({
                redireccionar: true,
                placa: "",
                tipo: "",
                modelo: "",
                marca: "",
                color: "",
                nit: "",
                dpi: "",
                nombre: "",
                nombrec: "",
                licencia: "",
                tipolicencia: "",
                lugar: "",
                observaciones: "",
                foto: null,
                infraccionesSeleccionadas: []
            });

        } else {
            alert(respuesta.error || "Error al guardar la multa");
        }
    })
    .catch(error => {
        alert("Error al conectar con el servidor");
    });
}


  cargarTiposPlaca() {
    fetch(api + "tipos-placa", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

       

        this.setState({
            tiposPlaca: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });

    })
    .catch(error => {
     
        this.setState({
            tiposPlaca: []
        });
    });
}

     agregarInfraccion = () => {

    const infraccion = this.state.infraccionActual;

    if (!infraccion) {
        alert("Seleccione una infracción");
        return;
    }

    const yaExiste = this.state.infraccionesSeleccionadas.some(
    item => String(item.idinfraccion) === String(infraccion.idinfraccion)
);

    if (yaExiste) {
        alert("La infracción ya fue agregada");
        return;
    }

    this.setState({
        infraccionesSeleccionadas: [
            ...this.state.infraccionesSeleccionadas,
            infraccion
        ],
        incisoSeleccionado: "",
        infraccionActual: null
    });
}

 cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    cambioFoto = (e) => {
    this.setState({
        foto: e.target.files[0]
    });
}

quitarInfraccion = (idinfraccion) => {

    const nuevasInfracciones =
        this.state.infraccionesSeleccionadas.filter(
            item => String(item.idinfraccion) !== String(idinfraccion)
        );

    this.setState({
        infraccionesSeleccionadas: nuevasInfracciones
    });

}

       



        cargarDatos() {
    fetch(api + "infracciones", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {
        this.setState({
            datosCargados: true,
            infracciones: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });
    })
    .catch(error => {
       
        this.setState({
            datosCargados: true,
            infracciones: []
        });
    });
}

cargarArticulos() {
    fetch(api + "infracciones/articulos", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {
        this.setState({
            articulos: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });
    })
    
}

cargarIncisos(articulo) {
    fetch(api + "infracciones/" + articulo + "/incisos", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {
        this.setState({
            incisos: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });
    })
    
}

filtrarArticulo = (e) => {
    const articulo = e.target.value;

    this.setState({
        articuloSeleccionado: articulo,
        incisoSeleccionado: "",
        incisos: [],
        infraccionActual: null
    });

    if (articulo === "") {
        this.cargarDatos();
    } else {
        this.cargarIncisos(articulo);

        fetch(api + "infracciones/por-articulo/" + articulo, {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then((datosRespuesta) => {
            this.setState({
                infracciones: Array.isArray(datosRespuesta) ? datosRespuesta : []
            });
        })
       
    }
}

filtrarInciso = (e) => {
    const idinfraccion = e.target.value;

    const infraccion = this.state.incisos.find(
        item => String(item.idinfraccion) === String(idinfraccion)
    );

    this.setState({
        incisoSeleccionado: idinfraccion,
        infraccionActual: infraccion || null
    });
}

imprimirMulta = async (id) => {
    try {
        const respuesta = await fetch(api + `reportes/multas/${id}/imprimir`, {
            method: "GET",
            headers: authHeaders()
        });

        if (!respuesta.ok) {
            const error = await respuesta.text();
            
            alert("No se pudo imprimir la multa.");
            return;
        }

        const blob = await respuesta.blob();
        const fileURL = window.URL.createObjectURL(blob);

        window.open(fileURL, "_blank");

    } catch (error) {
        
        alert("Error al imprimir la multa.");
    }
};

        componentDidMount() {
            this.cargarDatos();
            this.cargarArticulos();
            this.cargarTiposPlaca();
        }

        render() {

            if (this.state.redireccionar) {
    return <Navigate to="/listarmultas" />;
}
            
            const { datosCargados, infracciones, articulos, articuloSeleccionado, tiposPlaca, mensaje } = this.state;

            const totalMonto = this.state.infraccionesSeleccionadas.reduce(
        (total, item) => total + Number(item.monto || 0),
        0
    );

            if (!datosCargados) {
                return (<div>Cargando...</div>);
            }

           return (
    <div className="card">

        <div className="card-header">
            <h4 className="mb-0">Crear multa</h4>
        </div>

        <div className="card-body">
            {mensaje && (
                <div className="alert alert-success">
                    {mensaje}
                </div>
            )}

            <h5>Datos del Vehículo Infractor</h5>

            <div className="row mb-2">
                <div className="col-md-2">
                    <label>Placa</label>
                    <input
                        type="text"
                        name="placa"
                        className="form-control"
                        value={this.state.placa}
                        onChange={this.cambioValor}
                        onBlur={this.verificarPlaca}
                    />
                </div>
                <small className="text-muted">
                     {this.state.mensajePlaca}
                </small>

               <div className="col-md-3">
    <label>Tipo de placa</label>

    <select
    name="tipo"
    className="form-select"
    value={this.state.tipo}
    onChange={this.cambioValor}
    onBlur={this.verificarPlaca}
>
    <option value="">Seleccione</option>

    {tiposPlaca.map((item) => (
        <option
            key={item.idtipoplaca}
            value={item.idtipoplaca}
        >
            {item.tipo}
        </option>
    ))}
</select>
</div>

                <div className="col-md-2">
                    <label>Modelo</label>
                    <input
                        type="text"
                        name="modelo"
                        className="form-control"
                        value={this.state.modelo}
                        onChange={this.cambioValor}
                    />
                </div>

                <div className="col-md-2">
                    <label>Marca</label>
                    <input
                        type="text"
                        name="marca"
                        className="form-control"
                        value={this.state.marca}
                        onChange={this.cambioValor}
                    />
                </div>

                <div className="col-md-2">
                    <label>Color</label>
                    <input
                        type="text"
                        name="color"
                        className="form-control"
                        value={this.state.color}
                        onChange={this.cambioValor}
                    />
                </div>
            </div>
             
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Nombre Completo del Propietario</label>
                    <input
                        type="text"
                        name="nombre"
                        className="form-control"
                        value={this.state.nombre}
                        onChange={this.cambioValor}
                    />
                </div>

                 <div className="col-md-2">
                    <label>DPI</label>
                    <input
                        type="text"
                        name="dpi"
                        className="form-control"
                        value={this.state.dpi}
                        onChange={this.cambioValor}
                    />
                </div>

                <div className="col-md-2">
                    <label>Nit</label>
                    <input
                        type="text"
                        name="nit"
                        className="form-control"
                        value={this.state.nit}
                        onChange={this.cambioValor}
                    />
                </div>
                <h5>DATOS DEL INFRACTOR</h5>
                    <div className="col-md-3">
                     <label>Nombre del Conductor</label>
                         <input
                        type="text"
                        name="nombrec"
                        className="form-control"
                        value={this.state.nombrec}
                        onChange={this.cambioValor}
                    />
                </div>
                <div className="col-md-3">
                    <label>¿Posee licencia?</label>
                        <select
                            name="licencia"
                            className="form-select"
                            value={this.state.licencia}
                            onChange={this.cambioValor}
                         >
                            <option value="">Seleccione</option>
                            <option value="SI">Sí</option>
                            <option value="NO">No</option>
                        </select>
                    </div>
                <div className="col-md-3">
                     <label>Tipo licencia</label>
                         <select
                        name="tipolicencia"
                        className="form-select"
                        value={this.state.tipolicencia}
                        onChange={this.cambioValor}
                        disabled={this.state.licencia === "NO"}
                    >
                            <option value="">Seleccione</option>
                            <option value="M">M</option>
                            <option value="C">C</option>
                            <option value="B">B</option>
                            <option value="A">A</option>
                            <option value="E">E</option>
                        </select>
                </div>
                 <h5 className="mt-4">DATOS DELA INFRACCION</h5>
                 <div className="col-md-3">
                     <label>Lugar</label>
                         <input
                        type="text"
                        name="lugar"
                        className="form-control"
                        value={this.state.lugar}
                        onChange={this.cambioValor}
                    />
                </div>
             
              

                    <div className="col-md-9">
                     <label>Observaciones</label>
                        <textarea
                        name="observaciones"
                        className="form-control"
                        value={this.state.observaciones}
                        onChange={this.cambioValor}
                    />
                </div>

                <div className="col-md-6 mt-3">
    <label>Evidencia fotográfica</label>

    <input
        type="file"
        accept="image/*"
        capture="environment"
        className="form-control"
        onChange={this.cambioFoto}
    />

    {this.state.foto && (
        <small className="text-success">
            {this.state.foto.name}
        </small>
    )}
</div>


            </div>

            <h5 className="mt-4">Seleccionar infracción</h5>

            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Artículo</label>
                    <select
                        className="form-select"
                        name="articuloSeleccionado"
                        value={articuloSeleccionado}
                        onChange={this.filtrarArticulo}
                    >
                        <option value="">Seleccione artículo</option>

                        {articulos.map((item) => (
                            <option key={item.articulo} value={item.articulo}>
                                Artículo {item.articulo}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-6">
                    <label>Inciso</label>
                    <select
                        className="form-select"
                        name="incisoSeleccionado"
                        value={this.state.incisoSeleccionado}
                        onChange={this.filtrarInciso}
                        disabled={!articuloSeleccionado}
                    >
                        <option value="">Seleccione inciso</option>

                        {this.state.incisos.map((item) => (
                            <option
                                key={item.idinfraccion}
                                value={item.idinfraccion}
                            >
                                Inciso {item.inciso} - {item.descripcion}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2 d-flex align-items-end">
                    <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={this.agregarInfraccion}
                        disabled={!this.state.incisoSeleccionado}
                    >
                        Agregar
                    </button>
                </div>
            </div>

            <h5 className="mt-4">Infracciones agregadas</h5>

            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Artículo</th>
                        <th>Inciso</th>
                        <th>Descripción</th>
                        <th>Monto</th>
                        <th>Acción</th>
                    </tr>
                </thead>

                <tbody>
                    {this.state.infraccionesSeleccionadas.map((item) => (
                        <tr key={item.idinfraccion}>
                            <td>{item.articulo}</td>
                            <td>{item.inciso}</td>
                            <td>{item.descripcion}</td>
                            <td>Q. {Number(item.monto || 0).toFixed(2)}</td>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => this.quitarInfraccion(item.idinfraccion)}
                                >
                                    Quitar
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="text-end mt-3">
                <h5>Total: Q. {totalMonto.toFixed(2)}</h5>
            </div>

            <div className="text-end mt-3">
   

    <button
        type="button"
        className="btn btn-primary mt-2"
        onClick={this.guardarMulta}
        disabled={this.state.infraccionesSeleccionadas.length === 0}
    >
        Guardar multa
    </button>
</div>
        </div>

        <div className="card-footer text-muted"></div>
    </div>
);
        }
    }

    export default Crearmultas;